var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-sidebar',{attrs:{"id":"sidebar-1","title":"Closer","shadow":""}},[_c('div',{staticClass:"px-3 py-2"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }